import { IRecipient, StoreCategory } from '@tiendanube/common';
import { PersonalDataState } from 'domains/PagoNubeOnboarding/Onboarding/types';

const getLine = (street?: string, streetNumber?: number): string => {
  if (street && streetNumber && streetNumber !== 0)
    return `${street} ${streetNumber}`;
  return '';
};

const toStoreCategory = (value?: string): StoreCategory | undefined => {
  if (!value) return undefined;
  return value as unknown as StoreCategory;
};

export const mapPersonalDataToRecipient = (
  personalDataState: PersonalDataState,
): IRecipient => ({
  kyc: {
    category: toStoreCategory(personalDataState?.storeCategory),
    phoneNumber: personalDataState?.phoneNumber,
    phoneNumberPrefix: personalDataState?.phoneNumberPrefix || '+52',
    address: {
      postalCode: personalDataState?.zipCode,
      city: personalDataState?.city,
      state: personalDataState?.state,
      line: getLine(personalDataState?.street, personalDataState?.streetNumber),
    },
    individual: {
      birthDate: personalDataState?.birthDate,
      firstName: personalDataState?.firstName,
      lastName: personalDataState?.lastName,
    },
  },
});
